import { useEffect, useState } from 'react'
import { startDocsSession } from '../api/docs'
import { DOCS_ROOT, docsTarget } from './docsLinks'

/**
 * Where nginx sends a docs request that has no good docs cookie. By the time this renders `AuthGate` has signed
 * the person in, coming back to this same URL; this trades that session for the docs cookie and replaces itself
 * with the page they asked for, so the back button skips it.
 */
export function DocsSignin() {
  const [failed, setFailed] = useState(false)

  useEffect(() => {
    const target = docsTarget(window.location.pathname, window.location.search, window.location.hash)
    startDocsSession().then(
      () => window.location.replace(target),
      () => setFailed(true),
    )
  }, [])

  return (
    <div className="flex min-h-screen items-center justify-center bg-content-bg p-lg text-fg">
      {failed ? (
        <div className="max-w-md text-center">
          <p className="mb-sm font-medium">The documentation couldn&apos;t be opened.</p>
          <p className="text-sm text-fg-muted">
            Try again in a moment, or <a href={DOCS_ROOT}>go to the documentation</a>.
          </p>
        </div>
      ) : (
        <p className="text-sm text-fg-muted">Opening the documentation…</p>
      )}
    </div>
  )
}
